import { TranslationService } from 'gast-common-ng';
/**
 * Class contains URL Paths for http requests
 */
var UrlService = /** @class */ (function () {
    function UrlService(envConfig, translationService) {
        this.envConfig = envConfig;
        this.translationService = translationService;
        this.environment = this.envConfig.callback(this.envConfig.value);
    }
    // COURSES
    UrlService.prototype.getCourses = function () {
        return this.environment.courseServiceUrl + "api/public/courses";
    };
    UrlService.prototype.getCourseFormats = function () {
        return this.environment.courseServiceUrl + "api/public/courses/format";
    };
    UrlService.prototype.getCourseClassificationCheck = function () {
        return this.environment.courseServiceUrl + "api/my-account/classification";
    };
    UrlService.prototype.getBookingConfirmation = function () {
        return this.environment.courseServiceUrl + "api/my-account/confirmation";
    };
    UrlService.prototype.saveBookingIdPair = function () {
        return this.environment.courseServiceUrl + "api/my-account/booking-id-pair";
    };
    // Languages for DUO
    UrlService.prototype.getAllLanguages = function () {
        return this.environment.coreServiceUrl + "api/public/languages/duo";
    };
    // get code encash validations
    UrlService.prototype.getCodeEncashRequiredPersonalIdent = function () {
        return this.environment.courseServiceUrl + "api/public/code-encash/required-personal-ident";
    };
    // submit code encash validations
    UrlService.prototype.getCodeEncashValidatePersonalIdent = function () {
        return this.environment.courseServiceUrl + "api/public/code-encash/validate-personal-ident";
    };
    // get imported person identification
    UrlService.prototype.getImportedPersonalIdent = function () {
        return this.environment.courseServiceUrl + "api/public/code-encash/personal-identifications";
    };
    // get duo program
    UrlService.prototype.getDuoProgram = function () {
        return this.environment.courseServiceUrl + "api/public/code-encash/duo-program";
    };
    // get core person identification
    UrlService.prototype.getCorePersonalIdent = function () {
        return this.environment.courseServiceUrl + "api/webshop/personal-identifications";
    };
    // get self assessment result
    UrlService.prototype.getSelfAssessmentResult = function () {
        return this.environment.courseServiceUrl + "api/public/self-assessments";
    };
    UrlService.prototype.getCreateBookingAndCourseArticle = function () {
        return this.environment.courseServiceUrl + "api/courses/bookings";
    };
    // get code encash with courses for the given code
    UrlService.prototype.getCodeEncashWithCourses = function () {
        return this.environment.courseServiceUrl + "api/public/courses/code-encash-with-courses";
    };
    UrlService.prototype.getLearnerPortalUrl = function () {
        return "" + this.environment.duoLearnerPortalUrl;
    };
    UrlService.prototype.getHeidelpayServiceUrl = function () {
        return "" + this.environment.hcoServiceUrl;
    };
    UrlService.prototype.getHcoErroCodeUrl = function () {
        return this.environment.bookingServiceUrl + "api/hco-error-code/";
    };
    UrlService.prototype.getWebshopStepUrl = function () {
        return this.environment.courseServiceUrl + "api/public/webshop/steps";
    };
    UrlService.prototype.getWebshopConfigUrl = function () {
        return this.environment.courseServiceUrl + "api/public/webshop/webshop-config";
    };
    UrlService.prototype.getWebshopViewStepUrl = function () {
        return this.environment.courseServiceUrl + "api/public/webshop/views";
    };
    UrlService.prototype.getWebshopDatafileUrl = function () {
        return this.environment.courseServiceUrl + "api/public/webshop/datafile/webshop-config";
    };
    UrlService.prototype.getDuoUniversitiesUrl = function () {
        return this.environment.courseServiceUrl + "api/public/webshop/duo-universities";
    };
    UrlService.prototype.getCountriesUrl = function () {
        return this.environment.courseServiceUrl + "api/public/webshop/countries";
    };
    UrlService.prototype.getIntakeRegistrationURL = function () {
        return this.environment.courseServiceUrl + "api/public/webshop/intake-registration";
    };
    UrlService.prototype.getValidateLoggedUserForIntakeUrl = function () {
        return this.environment.courseServiceUrl + "api/webshop/validate-logged-person-code";
    };
    UrlService.prototype.getDataPrivacyProtectionUrl = function () {
        return "https://www.deutsch-uni.com/gast/duo/info/index/datenschutz.jsp";
    };
    UrlService.prototype.getTermOfServiceUrl = function () {
        var lang = this.translationService.getCurrentLanguageCode().toLocaleLowerCase();
        switch (lang) {
            case 'de':
                return 'http://www.deutsch-uni.com/de/agb';
            case 'en':
                return 'http://www.deutsch-uni.com/en/gtc';
            default:
                return 'http://www.deutsch-uni.com/de/agb';
        }
    };
    UrlService.prototype.getClassificationDeadlineDateUrl = function () {
        return this.environment.courseServiceUrl + "api/my-account/classification-deadline";
    };
    UrlService.prototype.getIsfAlemaoUrl = function () {
        return "https://www.isf-alemao.de/";
    };
    UrlService.prototype.getPublicCourseScheduleUrl = function () {
        return this.environment.courseServiceUrl + "api/public/course-schedules";
    };
    UrlService.prototype.getPublicCategoryUrl = function () {
        return this.environment.courseServiceUrl + "api/public/webshop/categories";
    };
    UrlService.prototype.getPublicLanguageGradingResultUrl = function () {
        return this.environment.courseServiceUrl + "api/public/webshop/language-grading-results";
    };
    UrlService.prototype.getPublicLearnFormatUrl = function () {
        return this.environment.courseServiceUrl + "api/public/webshop/learn-formats";
    };
    UrlService.prototype.getIndividualRegistrationURL = function () {
        return this.environment.courseServiceUrl + "api/public/webshop/individual-registration";
    };
    UrlService.prototype.getPersonalDataUrl = function () {
        return this.environment.duoLearnerPortalUrl + "dashboard/my-data";
    };
    UrlService.prototype.getBookNextCourseUrl = function () {
        return this.environment.courseServiceUrl + "api/public/intakes/next-course";
    };
    UrlService.prototype.getBookingWithVoucherUrl = function () {
        return this.environment.courseServiceUrl + "api/courses/bookings-with-voucher";
    };
    UrlService.prototype.getTeaserUrl = function () {
        return this.environment.courseServiceUrl + "api/public/webshop-teaser";
    };
    // portal account
    UrlService.prototype.getPortalAccountLoginUrl = function () {
        return this.environment.accountPortalUrl + "login";
    };
    UrlService.prototype.getPortalAccountRegisterUrl = function () {
        return this.environment.accountPortalUrl + "register";
    };
    UrlService.prototype.getLearnWithDuoUrl = function () {
        return "http://www.deutsch-uni.com/lernen-mit-duo";
    };
    UrlService.prototype.getInstitutionUrl = function () {
        return "http://www.deutsch-uni.com/institutionen";
    };
    UrlService.prototype.getAboutDuoUrl = function () {
        return "http://www.deutsch-uni.com/ueber-duo";
    };
    UrlService.prototype.getWebshopPortalUrl = function () {
        return this.environment.duoWebshopUrl + "course";
    };
    UrlService.prototype.getRegistrationInfoEventUrl = function () {
        return this.environment.courseServiceUrl + "api/public/registration-info-event";
    };
    UrlService.prototype.getRegistrationInfoEventConfirmMailUrl = function () {
        return this.environment.courseServiceUrl + "api/public/registration-info-event/confirm-mail";
    };
    UrlService.prototype.getRegistrationLectorTrainingUrl = function () {
        return this.environment.courseServiceUrl + "api/public/registration-lector-training";
    };
    UrlService.prototype.getOnsiteLectorRegisterUrl = function () {
        return this.environment.courseServiceUrl + "api/public/onsite-lector/register";
    };
    UrlService.prototype.getOnsiteLectorLoginUrl = function () {
        return this.environment.courseServiceUrl + "api/public/onsite-lector/login";
    };
    UrlService.prototype.getOnsiteLectorSelectCourseUrl = function () {
        return this.environment.courseServiceUrl + "api/public/onsite-lector/select-course";
    };
    UrlService.prototype.getAlreadyBooked = function () {
        return this.environment.bookingServiceUrl + "api/booking/course-schedule-id";
    };
    UrlService.prototype.checkAndSavePKZ = function () {
        return this.environment.courseServiceUrl + "api/programs/register-daad";
    };
    UrlService.prototype.checkAndSaveUniversity = function () {
        return this.environment.courseServiceUrl + "api/programs/register-dfh";
    };
    UrlService.prototype.mePersonUrl = function () {
        return this.environment.coreServiceUrl + "api/users/me/persons";
    };
    return UrlService;
}());
export { UrlService };
